import { writable, derived } from 'svelte/store';

export const config = writable(window.kbSearchServiceManager);
export const results = writable([]);
export const errorMessage = writable(null);
export const facetValues = writable([]);
export const searching = writable(true);
export const totalCount = writable(0);
export const searchTerm = writable('');
export const searchPage = writable(undefined);
export const lastUpdatedFacet = writable(undefined);
export const searchCursor = writable({
  endCursor: 0,
  hasNextPage: false,
  hasPreviousPage: false,
  startCursor: 0,
});

export let showAside = writable(false);

export let pages = derived([totalCount, config], ([$totalCount, $config]) =>
  Math.ceil($totalCount / $config.count)
);
export let currentPage = derived(
  [searchCursor, config, pages],
  ([$searchCursor, $config]) =>
    Math.ceil(Number($searchCursor.startCursor) / $config.count)
);
export let firstDisplayedPage = derived(currentPage, ($currentPage) =>
  Math.max(0, $currentPage - 2)
);
export let lastDisplayedPage = derived(
  [firstDisplayedPage, pages],
  ([$firstDisplayedPage, $pages]) => Math.min($firstDisplayedPage + 5, $pages)
);
export let trueFirstDisplayedPage = derived(
  [firstDisplayedPage, lastDisplayedPage],
  ([$firstDisplayedPage, $lastDisplayedPage]) =>
    $lastDisplayedPage - $firstDisplayedPage < 5
      ? Math.max(0, $lastDisplayedPage - 5)
      : $firstDisplayedPage
);

export function setShowAside(value) {
  showAside = !!value;
}
